import { render, staticRenderFns } from "./modalHistorialAceptacion.vue?vue&type=template&id=2f210e86&scoped=true&"
import script from "./modalHistorialAceptacion.vue?vue&type=script&lang=js&"
export * from "./modalHistorialAceptacion.vue?vue&type=script&lang=js&"
import style0 from "./modalHistorialAceptacion.vue?vue&type=style&index=0&id=2f210e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f210e86",
  null
  
)

export default component.exports